import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useBaseLayout = defineStore("baseLayout", () => {
  const navWidth = ref(0);
  const baseContainerWidth = ref(0);
  const baseContentRectLeft = ref(0);
  const currentPageWithMaxContainer = ref(false);
  const paddingLeftRight = ref(50);
  const fullSizeWidth = ref(0);
  const breakPoint = ref(1420);

  const baseContentWidth = computed(() => {
    return `${baseContainerWidth.value - navWidth.value - 100}`;
  });

  return {
    navWidth,
    baseContainerWidth,
    baseContentRectLeft,
    paddingLeftRight,
    currentPageWithMaxContainer,
    baseContentWidth,
    fullSizeWidth,
    breakPoint,
  };
});
